import { mutatorAction } from 'satcheljs';
import getStore, { createDefaultCalendarPickerStore } from '../store/store';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';

export const initializeCalendarPickerStore = mutatorAction(
    'initializeCalendarPickerStore',
    (scenarioId: CalendarPickerScenarioId) => {
        const store = getStore();

        if (!store.scenarioStores.has(scenarioId)) {
            store.scenarioStores.set(scenarioId, { ...createDefaultCalendarPickerStore() });
        }
    }
);
